import React from 'react'
import marked from 'marked'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'
import { slugify } from '../utils'
import useAvatar from '../utility/useAvatar'
import User from '../images/svg-icons/user-light.svg'


const BioDetail = ({ speaker, intervento }) => {
  const avatar = useAvatar();
  return (
    <section id="bio-detail" className={`section bio-detail ${intervento && slugify(intervento.tipologia)}`} aria-labelledby="region1">
      <div className="container">
        <div className="row" data-aos="fade-up">
          <div className="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
            <div className="row">
              <div className="col-md-4">
                <div className="bio-detail__person">
                  <figure className="bio-detail__figure">
                    {speaker.imageFile ? (
                      <Img fluid={speaker.imageFile.childImageSharp.fluid} alt={speaker.title} className="bio-detail__img" />
                    ): (
                      <div className="bio-detail__img-wrapper">
                        <User />
                        <img src={avatar.publicURL} alt={speaker.title} className="bio-detail__img" />
                      </div>
                    )}
                    <span className="bio-detail__icon">
                      {!!speaker.workshop && <span className="workshop"></span>}
                      {!!speaker.casestudy && <span className="casestudy"></span>}
                      {!!speaker.presentazione && <span className="presentazione"></span>}
                      {!!speaker.esposizione && <span className="esposizione"></span>}
                      {!!speaker.keynote && <span className="keynote"></span>}
                      {!!speaker.socialconsulting && <span className="social-consulting"></span>}
                    </span>
                  </figure>
                  <div className="bio-detail__program">
                    {!!speaker.workshop && <span className="workshop"><FormattedMessage id="workshop"/></span>}
                    {!!speaker.casestudy && <span className="casestudy"><FormattedMessage id="casestudy"/></span>}
                    {!!speaker.presentazione && <span className="presentazione"><FormattedMessage id="presentazione"/></span>}
                    {!!speaker.esposizione && <span className="esposizione"><FormattedMessage id="expo"/></span>}
                    {!!speaker.keynote && <span className="keynote"><FormattedMessage id="keynote"/></span>}
                    {!!speaker.socialconsulting && <span className="social-consulting"><FormattedMessage id="social-consulting"/></span>}
                  </div>
                  <span className="bio-detail__name">{speaker.title}</span>
                  {!!(speaker.twitter || speaker.linkedin) && (
                    <div className="bio-detail__social">
                      {!!speaker.twitter && <a href={speaker.twitter} title="Twitter" target="_blank" rel="noopener noreferrer" className="">
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>}
                      {!!speaker.linkedin && <a href={speaker.linkedin} title="LinkedIn" target="_blank" rel="noopener noreferrer" className="">
                        <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>}
                    </div>
                  )}
                  {!!speaker.pubblicazioni && (
                    <div className="bio-detail__pub">
                      <div className="bio-detail__pubtitle"><FormattedMessage id="pubblicazioni"/></div>
                      <div dangerouslySetInnerHTML={{__html: marked(speaker.pubblicazioni)}}></div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-8">
                <h1 id="region1" className="bio-detail__title">{speaker.jobtitle}</h1>
                <div className="bio-detail__bodytext" dangerouslySetInnerHTML={{__html: marked(speaker.bio)}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BioDetail
